import { GESTURE_MAP } from './gestures';

// Chat-intent → gesture rules. First match wins; every id must exist in the
// gesture catalog (all six below ship in the default loadout set). Used for
// BOTH the local player's outgoing vicinity messages and NPC replies.
const RULES: { pattern: RegExp; gesture: string }[] = [
  { pattern: /(\u{1F602}|\u{1F923}|\u{1F606})|\b(ha(ha)+h*|lol|lmao|rofl)\b/iu, gesture: 'laughing' },
  { pattern: /(\u{1F44F})|\b(bravo|applause|applaud|well done|congrats|congratulations)\b/iu, gesture: 'clapping' },
  { pattern: /(\u{1F483}|\u{1F57A})|\bdanc(e|ing|es)\b/iu, gesture: 'dance' },
  { pattern: /(\u{1F618}|\u{1F48B}|❤️?|\u{1F60D})|\b(kiss(es)?|love (you|it|this)|xoxo)\b/iu, gesture: 'blow-a-kiss' },
  { pattern: /(\u{1F389}|\u{1F973})|\b(yay+|woo+h*o*|hooray|awesome|amazing|cheers)\b/iu, gesture: 'cheer' },
  { pattern: /(\u{1F44B})|\b(hi|hii+|hello+|hey+|heya|shalom|hola|welcome|greetings)\b/iu, gesture: 'wave' },
];

/** Gesture id matching the message text, or null. */
export function gestureForMessage(text: string): string | null {
  if (!text) return null;
  for (const rule of RULES) {
    if (rule.pattern.test(text)) {
      return GESTURE_MAP.has(rule.gesture) ? rule.gesture : null;
    }
  }
  return null;
}

// Rate limit for AUTO-triggered gestures so rapid chat doesn't windmill the
// character. Explicit button presses are never limited.
const MIN_AUTO_INTERVAL_MS = 4000;
const lastAutoAt = new Map<string, number>();

/**
 * Rate-limited variant for automatic triggering. `actorKey` scopes the limit
 * per character ('self', or an npc id) so an NPC gesturing doesn't starve the
 * player's own auto-gesture and vice versa.
 */
export function autoGestureForMessage(text: string, actorKey: string): string | null {
  const gesture = gestureForMessage(text);
  if (!gesture) return null;
  const now = Date.now();
  const last = lastAutoAt.get(actorKey) ?? 0;
  if (now - last < MIN_AUTO_INTERVAL_MS) return null;
  lastAutoAt.set(actorKey, now);
  return gesture;
}
